import MenuEntry from '@/modules/cms/modules/menu/model/MenuEntry'
import { Module } from 'vuex'
import { RootState } from '@/store/types'
import actions from '@/modules/cms/modules/menu/store/actions'
import mutations from '@/modules/cms/modules/menu/store/mutations'
import getters from '@/modules/cms/modules/menu/store/getters'
import Slot from '../model/Slot';

export interface MenuState {

    /**
     * Lista de menus obtenidos del servidor
     */
    menuList: MenuEntry[]

    /**
     * Menú actual seleccionado por el usuario
     */
    currentMenu: MenuEntry,

    /**
     * Sub-elemento del menú seleccionado por el usuario
     */
    currentMenuItem: MenuEntry

    /**
     * Indica si se esta creando un nuevo elemento para el menu actual
     */
    creatingItem: boolean

    /**
     * Almacena el localismo de la traducción del menú actualmente seleccionada
     * por el usuario
     */
    currentLocale: string,

    /**
     * Identificador del elemento de menu donde se insertará el nuevo elemento creado
     */
    newItemInsertionPoint: string,

    /**
     * Indica si actualmente existe algún elemento seleccionado
     */
    itemSelected: boolean,

    slots: Slot[],
}

const module: Module<MenuState, RootState> = {
    mutations,
    actions,
    getters,
    namespaced: true,
    state: {
        menuList: [],
        currentMenu: new MenuEntry(),
        currentMenuItem: new MenuEntry(),
        creatingItem: false,
        currentLocale: '',
        newItemInsertionPoint: '',
        itemSelected: false,
        slots: [],
    },
}

export default module

